import { PageData } from '@/gem.types';

interface Props {
  element: any;
  theme: PageData['theme'];
}

const TextGemElement = ({ element, theme }: Props) => {
  const { gem } = element;

  return (
    <div
      className="prose lg:prose-xl mt-2 px-8 py-6 mb-10 rounded-2xl w-full bg-white"
      style={
        theme?.borderColor
          ? {
              border: `2px solid ${theme.borderColor}`
            }
          : {}
      }
    >
      <h3>{gem.name}</h3>
      <div dangerouslySetInnerHTML={{ __html: gem.text }} />
    </div>
  );
};

export default TextGemElement;
